// src/components/ProtectedRoute.jsx
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../Context/AuthProvider";
import LoadingSpinner from "../LoadingSpinner";

const ProtectRouteBasedOnRoles = ({
  children,
  requiredRoles = [],
  requireAll = true,
}) => {
  const { isLoading, userData, handleLogin } = useContext(AuthContext);
  const location = useLocation();
  const userRoles = userData?.userRoles || [];

  const hasAccess = requireAll
    ? requiredRoles.every((role) => userRoles.includes(role))
    : requiredRoles.some((role) => userRoles.includes(role));

  useEffect(() => {
    if (!isLoading && !hasAccess) {
      const target = location.pathname + location.search;

      try {
        localStorage.setItem("postLoginRedirect", target);
      } catch (e) {}

      handleLogin(target);
    }
  }, [isLoading, hasAccess, handleLogin, location]);
  if (isLoading) return <LoadingSpinner />;
  if (hasAccess) return children;

  return null;
};

export default ProtectRouteBasedOnRoles;
